import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

import {NgbModal, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {ReportEmailModalComponent} from '../report-email-modal/report-email-modal.component';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {LimitToPipe} from '@shared/pipes/limit-to.pipe';
import {SearchComponent} from '@shared/search/search.component';
import {GenericInlineComponent} from '@shared/inlines/generic/generic.component';
import {BaseService} from '@shared/services/base.service';
import {ToastService} from '@shared/services/toast.service';
import {ErrorHandlingService} from '@shared/services/error-handling.service';

@Component({
    selector: 'app-reports',
    templateUrl: './beach-reports.component.html',
    styleUrls: ['./beach-reports.component.scss'],
    imports: [
        DatePipe,
        LimitToPipe,
        NgbPaginationModule,
        FormsModule,
        SearchComponent,
        NgForOf,
        NgIf,
        GenericInlineComponent
    ]
})
export class BeachReportsComponent implements OnInit {
  currentPage: number = 1;
  baseUrl = environment.baseUrl;
  advisory_ranges: any;
  jellyFishMeta: any;
  loadingJellyFish: boolean = false;
  reportAdvisoryService: BaseService;
  items;
  meta;
  loading = true;

  constructor(public http: HttpClient, public toast: ToastService, public modal: NgbModal,
              public errorHandling: ErrorHandlingService) {
    this.reportAdvisoryService = new BaseService(`${environment.baseUrl}/beaches/reportadvisories/`, http);
  }

  ngOnInit(): void {
    this.http.get(`${environment.baseUrl}/beaches/advisoryactivity/reports`).subscribe((response) => {
      this.advisory_ranges = response;
    });

    this.reportAdvisoryService.loadMetadata().subscribe();
    this.reportAdvisoryService.getList().subscribe(r => {
      this.items = r.results;
      this.meta = r.meta;
      this.meta.type = 'beaches/reportadvisories';
      this.meta.display_fields = ['type', 'start_date', 'end_date', 'title', 'content'];
      this.loading = false;
    });

    this.loadingJellyFish = true;

  }

  send_email(advisory, email) {
    this.errorHandling.customErrorMessage = true;
    this.http.post(`${environment.baseUrl}/beaches/advisoryactivity/send_email/`,
      {
        subject: email.subject,
        body: email.body,
        include_attachment: email.include_attachment
      }, {
        params:
          {
            actual_startdate: advisory.actual_startdate,
            actual_stopdate: advisory.actual_stopdate
          }
      }).subscribe(() => {
      this.toast.success('Email sent');
    }, (error) => {
      this.toast.error(error.data.error);
    });
  }

  open_email_modal(advisory) {
    const m = this.modal.open(ReportEmailModalComponent, {size: 'lg', backdrop: 'static'});
    m.componentInstance.advisory = advisory;
    m.result.then((emailContents) => {
      this.send_email(advisory, emailContents);
    }).catch(function () {
      // do nothing
    });
  };
}
